import { Alert, Col, Row } from 'antd';
import { LoadingSpin } from '@/components/common';
import { useMessages } from '@/hooks';
import { useTranslation } from 'react-i18next';
import MessageItem from './MessageItem';

import './styles.css';

export interface MessageBodyProps {
  onChooseMessage: (id: string) => void;
}

export function MessagesList({ onChooseMessage }: MessageBodyProps) {

  const [t] = useTranslation(['common']);
  const { loading, messagesInbox } = useMessages();

  if (loading) {
    return <LoadingSpin className="min-h-[300px] justify-center" />;
  }

  return (
    <Row>
      <Col span={24}>
        <Row className="app-messages-list" gutter={[16, 16]}>
          {messagesInbox.length === 0 && (
            <Alert
              type="warning"
              message={t('common:messages.no-items-to-show')}
              className="w-full min-h-[50px] text-center"
            />
          )}
          {messagesInbox.map(({ id, read, forceRead, message }, key) => (
            <Col className="message-item-container" key={key} span={24}>
              <MessageItem
                id={id}
                isRead={read}
                date={message.date}
                subject={message.subject}
                onClick={onChooseMessage}
                important={forceRead} />
            </Col>
          ))}
        </Row>
      </Col>
    </Row>
  );
};

export default MessagesList;
